import { useToastedMutation } from '../../../ReactQuery';
import { post } from '../../../redux/api';
import type { ResolveUserRequest, ResolveUserResponse } from '../../../../shared/types/routes/auth/v2';

/**
 * Resolves an identifier (email or username) to the orgs the user can log into (`candidates`) and the orgs that claim
 * their domain (`signupSuggestions`). Backs the credential-entry step. Errors surface as a toast; success is silent —
 * the caller advances the login step from the returned response.
 */
export default function useResolveUser() {
  return useToastedMutation({
    mutationFn: async (request: ResolveUserRequest) => {
      const response = await post<ResolveUserRequest, ResolveUserResponse>('/api/auth/resolve-user', request);
      return response.data;
    },
    errorToastMessage: 'Could not resolve account',
  });
}
